import type { PageNavigation } from 'navigation/types';

import * as urls from '../urls';

export const DIVERSITY_EQUITY_INCLUSION_NAVIGATION: PageNavigation = {
  pageUrl: urls.getDEIUrl(),
  currentLink: { text: 'Diversity and Inclusion', href: urls.getDEIUrl() },
  links: [
    {
      text: 'Statement',
      href: urls.getDEIStatementUrl(),
    },
    {
      text: 'Our Commitment',
      href: urls.getDEICommitmentUrl(),
    },
    {
      text: 'Policy',
      href: urls.getDEIPolicyUrl(),
    },
    {
      text: 'Breaches',
      href: urls.getDEIBrachesUrl(),
    },
  ],
};
